import Interceptor from "@/plugins/interceptor.js";

const urlAPI = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_SECURITY}`;

const Security = {
  state: {
    listUsers: []
  },
  actions: {
    authenticate: async (_, model) => {
      try {
        const response = await Interceptor.postWithoutToken(`${urlAPI}/authenticate`,model);
        return response;
      } catch (error) {
        console.error(error);
      }
    },
    userCreate: async (_, model) => {
      try {
        const response = await Interceptor.post(`${urlAPI}/userCreate`,model);
        return response;
      } catch (error) {
        console.error(error);
      }
    },
    userUpdate: async (_, model) => {
      try {
        const response = await Interceptor.put(`${urlAPI}/userUpdate`, model);
        return response;
      } catch (error) {
        console.error(error);
      }
    },
    userDelete: async (_, params) => {
      try {
        const response = await Interceptor.put(`${urlAPI}/userDelete?userId=${params.userId}`, {});
        return response;
      } catch (error) {
        console.error(error)
      }
    },
    usersGet: async ( {commit} ) => {
      try {
        const response = await Interceptor.get(`${urlAPI}/usersGet`)
        commit('SET_listUsers', response.data)
        return response
      } catch (error) {
        console.error(error);
      }
    },
    changePass: async ( {}, model) => {
      try {
        const response = await Interceptor.put(`${urlAPI}/changePass`, model)
        return response
      } catch (error) {
        console.error(error);
      }
    }
  },
  mutations: {
    SET_listUsers(state, value) {
      state.listUsers = value
    }
  }
};

export default Security;